import { Component, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { register } from 'swiper/element/bundle';
import { FilterComponentComponent } from './components/filter-component/filter-component.component';
import { AuthService } from './data/service/auth.service';
import { UserService } from './data/service/user.service';
import { environment } from 'src/environments/environment';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  private user;

  constructor(
    private modalCtrl: ModalController,
    private authService: AuthService,
    private userService: UserService) { }

  async ngOnInit() {
    if (this.authService.currentUserValue) {
      this.user = await this.userService.getUser(this.authService.currentUserValue?.userId).toPromise();
    }
  }

  get pathname() {
    return window.location.pathname;
  }

  get showFullHeader() {
    if (this.authService.isLoggedIn()) {
      return true;
    }
    if (localStorage.getItem('filter_finished')) {
      return true;
    }

    return false;
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: FilterComponentComponent,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  get isFormPage() {
    return this.pathname.includes('forms/fillout');
  }

  get magirusTicketPage() {
    return this.pathname.includes('magirus-generate-ticket');
  }

  get isSpartaxFormPage() {
    if (this.user) {
      if (this.user.company && this.user?.company.companyId === environment.spartaxCompanyId && this.isFormPage) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
